import React from 'react';
import { useLocation } from 'react-router-dom';
// Local Import
import { ListIcon } from '../';
import { sideMenuRoutes } from '../../../router/config';
import assets from '../../../assets';

const SideMenu = () => {
  // USER LOCATION
  const location = useLocation();
  return (
    <React.Fragment>
      <div className='flex flex-col justify-start h-full'>
        {/* LOGO WITH NAME */}
        <div className='flex justify-between cursor-pointer py-[16px] px-1 items-center sticky top-0'>
          <div className='flex items-center  w-full justify-center'>
            <img src={assets.logo} className='object-fit w-max h-[50px]' alt='Rylyf' />
          </div>
        </div>

        {/* MENUS */}
        <div className='flex flex-col gap-[8px] h-full overflow-auto'>
          {sideMenuRoutes.map((route: any, index: number) => {
            const isActive = location.pathname === route.path;
            return (
              <ListIcon
                key={index}
                text={route.text}
                icon={isActive ? route.activeIcon : route.icon}
                link={route.path}
                isActive={isActive}
              />
            );
          })}
        </div>

        {/* BOTTOM LINKS */}
        <div className='mt-auto'>
          {/* <div className='flex flex-col gap-[5px] pb-[27px] pt-[5px]'>
            <ListIcon text={'Invite teammates'} link='/dashboard' />
          </div> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default SideMenu;
